import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  clearCustomerPriceTables,
  getCustomerPriceTables,
} from 'domains/Customers/CustomerPriceTables/customerPriceTablesSlice';
import {
  getCustomerPriceTablesData,
  getCustomerPriceTablesStatus,
} from 'domains/Customers/CustomerPriceTables/customerPriceTablesSlice/customerPriceTablesSelectors';

export default function useCustomerPriceTables(id?: string) {
  const dispatch = useAppDispatch();

  const customerPriceTablesData = useSelector(getCustomerPriceTablesData);
  const customerPriceTablesStatus = useSelector(getCustomerPriceTablesStatus);

  const fetchCustomerPriceTables = useCallback(() => {
    if (id) {
      dispatch(getCustomerPriceTables(id));
    }
  }, [dispatch, id]);

  const resetCustomerPriceTables = useCallback(() => {
    dispatch(clearCustomerPriceTables());
  }, [dispatch]);

  return {
    customerPriceTablesData,
    customerPriceTablesStatus,
    fetchCustomerPriceTables,
    resetCustomerPriceTables,
  };
}
